module.exports = __webpack_public_path__ + "img/video9.86e8b547.jpg";